import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './layouts/AdminLayout';
import { StudentLayout } from './layouts/StudentLayout';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
// Placeholder components for pages we haven't built yet
const PlaceholderPage = ({
  title
}: {
  title: string;
}) => <div className="space-y-6" data-id="element-0">
    <h1 className="text-2xl font-bold text-slate-900" data-id="element-1">{title}</h1>
    <div className="p-12 border-2 border-dashed border-slate-300 rounded-lg text-center text-slate-500" data-id="element-2">
      Page content for {title} coming soon
    </div>
  </div>;
// We will replace these imports with real page components as we build them
import { ManageCourses } from './pages/ManageCourses';
import { ViewCourse } from './pages/ViewCourse';
import { EditCourse } from './pages/EditCourse';
import { ExportCourse } from './pages/ExportCourse';
import { ExportUsers } from './pages/ExportUsers';
import { SectionQuestions } from './pages/SectionQuestions';
import { EditSectionQuestion } from './pages/EditSectionQuestion';
import { ViewSectionQuestion } from './pages/ViewSectionQuestion';
import { SearchUser } from './pages/SearchUser';
import { EditUser } from './pages/EditUser';
import { AddUserNote } from './pages/AddUserNote';
import { OrderSearch } from './pages/OrderSearch';
import { PrintOrder } from './pages/PrintOrder';
import { AdminArea } from './pages/AdminArea';
import { Dashboard } from './pages/Dashboard';
import { ModifyProfile } from './pages/ModifyProfile';
import { EditCourseStatus } from './pages/EditCourseStatus';
import { StaticPages } from './pages/StaticPages';
import { EditStaticPage } from './pages/EditStaticPage';
import { ViewStaticPage } from './pages/ViewStaticPage';
import { EmailDetails } from './pages/EmailDetails';
import { EditEmailDetail } from './pages/EditEmailDetail';
import { ViewEmailDetail } from './pages/ViewEmailDetail';
import { EditProfileCustomFields } from './pages/EditProfileCustomFields';
import { EditEmailNotifications } from './pages/EditEmailNotifications';
import { EditDirectionText } from './pages/EditDirectionText';
import { CreditTypes } from './pages/CreditTypes';
import { EditCreditType } from './pages/EditCreditType';
import { ViewCreditType } from './pages/ViewCreditType';
import { ManagePackages } from './pages/ManagePackages';
import { EditPackage } from './pages/EditPackage';
import { ViewPackage } from './pages/ViewPackage';
import { ManageCoupons } from './pages/ManageCoupons';
import { EditCoupon } from './pages/EditCoupon';
import { ViewCoupon } from './pages/ViewCoupon';
import { SwitchExpiredClass } from './pages/SwitchExpiredClass';
import { CourseSections } from './pages/CourseSections';
import { CourseSectionsByCourse } from './pages/CourseSectionsByCourse';
import { ViewCourseSection } from './pages/ViewCourseSection';
import { EditCourseSection } from './pages/EditCourseSection';
import { CourseSectionsList } from './pages/CourseSectionsList';
import { StudentDashboard } from './pages/student/StudentDashboard';
import { MyClasses } from './pages/student/MyClasses';
import { AvailableClasses } from './pages/student/AvailableClasses';
import { ClassHistory } from './pages/student/ClassHistory';
import { ManageProfile } from './pages/student/ManageProfile';
import { ViewCart } from './pages/student/ViewCart';
import { Products } from './pages/student/Products';
import { Checkout } from './pages/student/Checkout';
import { OrderHistory } from './pages/student/OrderHistory';
import { Instructions } from './pages/student/Instructions';
import { ClassDetail } from './pages/student/ClassDetail';
import { ClassContent } from './pages/student/ClassContent';
import { FinalExam } from './pages/student/FinalExam';
export function App() {
  return <WorkspaceProvider data-id="element-3">
      <Router data-id="element-4">
        <Routes data-id="element-5">
          {/* Print Order is a standalone page without the admin shell */}
          <Route path="/custom/orders/print_order/:orderId" element={<PrintOrder data-id="element-7" />} data-id="element-6" />

          {/* Student routes */}
          <Route path="/student/*" element={<StudentLayout data-id="element-9">
                <Routes data-id="element-10">
                  <Route path="/dashboard" element={<StudentDashboard data-id="element-12" />} data-id="element-11" />
                  <Route path="/my-classes" element={<MyClasses data-id="element-14" />} data-id="element-13" />
                  <Route path="/available-classes" element={<AvailableClasses data-id="element-16" />} data-id="element-15" />
                  <Route path="/class-history" element={<ClassHistory data-id="element-18" />} data-id="element-17" />
                  <Route path="/profile" element={<ManageProfile data-id="element-20" />} data-id="element-19" />
                  <Route path="/cart" element={<ViewCart data-id="element-22" />} data-id="element-21" />
                  <Route path="/products" element={<Products data-id="element-24" />} data-id="element-23" />
                  <Route path="/checkout" element={<Checkout data-id="element-26" />} data-id="element-25" />
                  <Route path="/orders" element={<OrderHistory data-id="element-28" />} data-id="element-27" />
                  <Route path="/instructions" element={<Instructions data-id="element-30" />} data-id="element-29" />
                  <Route path="/class/:slug" element={<ClassDetail data-id="element-32" />} data-id="element-31" />
                  <Route path="/class/:slug/content" element={<ClassContent data-id="element-34" />} data-id="element-33" />
                  <Route path="/class/:slug/final-exam" element={<FinalExam data-id="element-36" />} data-id="element-35" />
                  <Route path="*" element={<Navigate to="/student/dashboard" replace data-id="element-38" />} data-id="element-37" />
                </Routes>
              </StudentLayout>} data-id="element-8" />

          {/* All other routes are wrapped in AdminLayout */}
          <Route path="/*" element={<AdminLayout data-id="element-40">
                <Routes data-id="element-41">
                  <Route path="/" element={<Dashboard data-id="element-43" />} data-id="element-42" />

                  {/* Course Admin */}
                  <Route path="/courses" element={<ManageCourses data-id="element-45" />} data-id="element-44" />
                  <Route path="/courses/view/:id" element={<ViewCourse data-id="element-47" />} data-id="element-46" />
                  <Route path="/courses/edit/:id" element={<EditCourse data-id="element-49" />} data-id="element-48" />
                  <Route path="/courses/add" element={<EditCourse data-id="element-51" />} data-id="element-50" />
                  <Route path="/courses/:id/sections" element={<CourseSectionsByCourse data-id="element-53" />} data-id="element-52" />
                  <Route path="/sections" element={<CourseSections data-id="element-55" />} data-id="element-54" />
                  <Route path="/sections/view/:id" element={<ViewCourseSection data-id="element-57" />} data-id="element-56" />
                  <Route path="/sections/edit/:id" element={<EditCourseSection data-id="element-59" />} data-id="element-58" />
                  <Route path="/sections/add" element={<EditCourseSection data-id="element-61" />} data-id="element-60" />
                  <Route path="/export-course" element={<ExportCourse data-id="element-63" />} data-id="element-62" />
                  <Route path="/export-users" element={<ExportUsers data-id="element-65" />} data-id="element-64" />
                  <Route path="/questions" element={<SectionQuestions data-id="element-67" />} data-id="element-66" />
                  <Route path="/questions/view/:id" element={<ViewSectionQuestion data-id="element-69" />} data-id="element-68" />
                  <Route path="/questions/edit/:id" element={<EditSectionQuestion data-id="element-71" />} data-id="element-70" />
                  <Route path="/questions/add" element={<EditSectionQuestion data-id="element-73" />} data-id="element-72" />

                  {/* Management */}
                  <Route path="/users" element={<SearchUser data-id="element-75" />} data-id="element-74" />
                  <Route path="/users/edit/:id" element={<EditUser data-id="element-77" />} data-id="element-76" />
                  <Route path="/users/notes/add" element={<AddUserNote data-id="element-79" />} data-id="element-78" />
                  <Route path="/orders" element={<OrderSearch data-id="element-81" />} data-id="element-80" />
                  <Route path="/admin-area" element={<AdminArea data-id="element-83" />} data-id="element-82" />

                  {/* Admin Area Sub-pages */}
                  <Route path="/static-pages" element={<StaticPages data-id="element-85" />} data-id="element-84" />
                  <Route path="/static-pages/view/:id" element={<ViewStaticPage data-id="element-87" />} data-id="element-86" />
                  <Route path="/static-pages/edit/:id" element={<EditStaticPage data-id="element-89" />} data-id="element-88" />
                  <Route path="/email-details" element={<EmailDetails data-id="element-91" />} data-id="element-90" />
                  <Route path="/email-details/view/:id" element={<ViewEmailDetail data-id="element-93" />} data-id="element-92" />
                  <Route path="/email-details/edit/:id" element={<EditEmailDetail data-id="element-95" />} data-id="element-94" />
                  <Route path="/custom-fields" element={<EditProfileCustomFields data-id="element-97" />} data-id="element-96" />
                  <Route path="/notifications" element={<EditEmailNotifications data-id="element-99" />} data-id="element-98" />
                  <Route path="/direction-text" element={<EditDirectionText data-id="element-101" />} data-id="element-100" />
                  <Route path="/credit-types" element={<CreditTypes data-id="element-103" />} data-id="element-102" />
                  <Route path="/credit-types/view/:id" element={<ViewCreditType data-id="element-105" />} data-id="element-104" />
                  <Route path="/credit-types/edit/:id" element={<EditCreditType data-id="element-107" />} data-id="element-106" />
                  <Route path="/credit-types/add" element={<EditCreditType data-id="element-109" />} data-id="element-108" />
                  <Route path="/switch-expired" element={<SwitchExpiredClass data-id="element-111" />} data-id="element-110" />

                  {/* Packages */}
                  <Route path="/packages" element={<ManagePackages data-id="element-113" />} data-id="element-112" />
                  <Route path="/packages/view/:id" element={<ViewPackage data-id="element-115" />} data-id="element-114" />
                  <Route path="/packages/edit/:id" element={<EditPackage data-id="element-117" />} data-id="element-116" />
                  <Route path="/packages/add" element={<EditPackage data-id="element-119" />} data-id="element-118" />
                  <Route path="/coupons" element={<ManageCoupons data-id="element-121" />} data-id="element-120" />
                  <Route path="/coupons/view/:id" element={<ViewCoupon data-id="element-123" />} data-id="element-122" />
                  <Route path="/coupons/edit/:id" element={<EditCoupon data-id="element-125" />} data-id="element-124" />
                  <Route path="/coupons/add" element={<EditCoupon data-id="element-127" />} data-id="element-126" />
                  <Route path="/profile" element={<ModifyProfile data-id="element-129" />} data-id="element-128" />
                  <Route path="/profile/course-status/edit/:id" element={<EditCourseStatus data-id="element-131" />} data-id="element-130" />
                </Routes>
              </AdminLayout>} data-id="element-39" />
          <Route path="/course-sections" element={<AdminLayout data-id="element-133">
                <CourseSections data-id="element-134" />
              </AdminLayout>} data-id="element-132" />
        </Routes>
      </Router>
    </WorkspaceProvider>;
}